import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  useDisclosure,
  Input,
  useToast,
} from '@chakra-ui/react'
import { useState } from 'react'
import { limpezaCache } from '../functions'

export function LimpezaCache() {
  const { isOpen, onOpen, onClose } = useDisclosure()

  const [codprod, setCodprod] = useState('')
  const [loading, setLoading] = useState(false)

  const toast = useToast({
    position: 'top',
  })

  async function handleClearCache(e) {
    e.preventDefault()
    setLoading(true)

    const response = await limpezaCache({
      codigo_produto: codprod,
    })

    console.log(response)

    if (response.status === 200) {
      toast({
        title: 'Sucesso!',
        description: 'Cache limpo com sucesso!',
        status: 'success',
        duration: 5000,
        isClosable: true,
      })

      setCodprod('')
      onClose()
    }

    setLoading(false)
  }

  return (
    <>
      <Button onClick={onOpen} variant="outline" maxW="300px" w="100%">
        Limpeza de cache por produto
      </Button>

      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent as="form" onSubmit={handleClearCache}>
          <ModalHeader>Limpeza de cache por produto</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Input
              placeholder="Digite o código do produto"
              value={codprod}
              onChange={(e) => setCodprod(e.target.value)}
            />
          </ModalBody>

          <ModalFooter>
            <Button colorScheme="blue" mr={3} onClick={onClose}>
              Fechar
            </Button>
            <Button variant="ghost" type="submit" isLoading={loading}>
              Limpar cache
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  )
}
